// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDMEW9ygG_nq5HEjWCDMmCgo0hO1lVWTCQ",
  authDomain: "csci342-project.firebaseapp.com",
  projectId: "csci342-project",
  storageBucket: "csci342-project.appspot.com",
  messagingSenderId: "267161968981",
  appId: "1:267161968981:web:8304fddd02d85959794fdc",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export default app;
